import { Component } from '@angular/core';

@Component({
  selector: 'app-screen-launcher-test',
  template: `
    <div style="padding: 40px;">
      <h1>🎯 Screen Launcher Test Component</h1>      
    </div>
  `,
  standalone: false
})
export class ScreenLauncherTestComponent {
  constructor() {
    console.log('✅ ScreenLauncherTestComponent carregou com sucesso!');
  }
}




























